import { FeatureFlagDirectiveModule } from './../shared/directives/feature-flag/feature-flag.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertMessageModule, HubLogoModule, HubNavModule, ModalModule, SimpleModalModule, SvgIconModule, TrAccordionModule } from '@toro/common/shared/components';
import { TooltipDirectiveModule, TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { DateISOStringPipeModule } from '@toro/common/shared/pipes';
import { FeatureFlagService } from '@toro/common/shared/services/feature-flag/feature-flag.service';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { StockPipesModule } from '../pipes/stock-pipes.module';
import { GlobalModule } from './../global.module';
import { CardHeaderComponent } from './cards/card-header/card-header.component';
import { CardLoadingComponent } from './cards/card-loading/card-loading.component';
import { CardTraderComponent } from './cards/card-trader/card-trader.component';
import { CardWarningComponent } from './cards/card-warning/card-warning.component';
import { GroupedCardComponent } from './cards/grouped-card/grouped-card.component';
import { MarketCardComponent } from './cards/market-card/market-card.component';
import { OpportunityCardComponent } from './cards/opportunity-cards/opportunity-card/opportunity-card.component';
import { PlanedCardComponent } from './cards/planned-card/planned-card.component';
import { StockResultsComponent } from './cards/stock-results/stock-results.component';
import { StructuredProductCardComponent } from './cards/structured-product-card/structured-product-card.component';
import { UnplanedCardComponent } from './cards/unplanned-card/unplanned-card.component';
import { HubChipComponent } from './hub-chip/hub-chip.component';
import { HubDraggableComponent } from './hub-draggable/hub-draggable.component';
import { HubHistoryComponent } from './hub-history/hub-history.component';
import { HubLiveSectionComponent } from './hub-live-section/hub-live-section.component';
import { HubSearchComponent } from './hub-search/hub-search.component';
import { LiveVideoComponent } from './live-video/live-video.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { RankTraderComponent } from './stamps/rank-trader/rank-trader.component';
import { TimeInCategoryComponent } from './stamps/time-in-category/time-in-category.component';
import { CheckoutReviewComponent } from './checkout-review/checkout-review.component';
import { VimeoPopVideoComponent } from './vimeo-pop-video/vimeo-pop-video.component';

const COMPONENTS = [
    HubSearchComponent,
    HubChipComponent,
    SkeletonComponent,
    HubHistoryComponent,
    LiveVideoComponent,
    HubLiveSectionComponent,
    HubDraggableComponent,
    VimeoPopVideoComponent,
    CardHeaderComponent,
    CardLoadingComponent,
    OpportunityCardComponent,
    MarketCardComponent,
    PlanedCardComponent,
    StockResultsComponent,
    UnplanedCardComponent,
    StructuredProductCardComponent,
    CardWarningComponent,
    GroupedCardComponent,
    RankTraderComponent,
    ProgressBarComponent,
    TimeInCategoryComponent,
    CardTraderComponent,
    CheckoutReviewComponent
];

@NgModule({
    imports: [
        GlobalModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        TrSpinnerButtonDirectiveModule,
        TooltipDirectiveModule,
        HubNavModule,
        HubLogoModule,
        SimpleModalModule,
        ModalModule,
        SvgIconModule,
        DateISOStringPipeModule,
        TrAccordionModule,
        DragDropModule,
        StockPipesModule,
        TypeaheadModule.forRoot(),
        AlertMessageModule,
        FeatureFlagDirectiveModule
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS,
    providers: [
        {provide: MatDialogRef, useValue: {}},
        FeatureFlagService,
    ],
})
export class ComponentsModule { }
